/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const PuzzlePieceSolidV6 = (props) => (
  <Icon {...props} name="Puzzle Piece Solid V6">
    <path d="M16 9c0 1.105-.672 2-1.5 2-1.013 0-.991-1-1.739-1a.76.76 0 0 0-.761.762V15a1 1 0 0 1-1 1H8.761A.761.761 0 0 1 8 15.237c0-.766 1-.725 1-1.737 0-.828-.895-1.5-2-1.5s-2 .672-2 1.5c0 1.013 1 .991 1 1.739a.761.761 0 0 1-.763.761H1a1 1 0 0 1-1-1v-4.238A.76.76 0 0 1 .761 10c.74 0 .726 1 1.739 1 .828 0 1.5-.897 1.5-2s-.672-2.028-1.5-2.028c-1.013 0-.991 1-1.739 1-.42 0-.761-.313-.761-.734V4.999c0-.552.448-.972 1-.972h4.237c.422-.055.763-.368.763-.789 0-.74-1-.726-1-1.739C5 .671 5.895.027 7 .027s2 .672 2 1.472c0 1.013-1 .991-1 1.739 0 .42.341.761.761.761H11c.552 0 1 .448 1 .972V7.21c0 .42.341.761.761.761.74 0 .726-1 1.739-1 .828.001 1.5.926 1.5 2.029z" />
  </Icon>
);

export default PuzzlePieceSolidV6;
